import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import useQuery from "../../../../hooks/useQuery";
import { showErrorToastify } from "../../../../utils";
import { getCompra, getMesasCompra } from "../api";
import { toast } from 'react-toastify';

// los adicionales de una mesa (menor, silla extra) se ven dentro del ticket de la mesa
const conMesas = (compra, mesas) => {
  if (!compra || !mesas) return compra;
  const ocultos = new Set(mesas.ocultos);
  const tickets = compra.tickets
    ?.filter((t) => !ocultos.has(t.id))
    .map((t) => (mesas.mesas[t.id] ? { ...t, detalle_mesa: mesas.mesas[t.id] } : t));
  return { ...compra, tickets };
};

const useCompra = (compraId) => {
  const [unauthorized, setUnauthorized] = useState(false);
  const [mesas, setMesas] = useState(null);
  const history = useHistory();

 const { data, refetch, loading } = useQuery({
    autoFetch: false,
    queryFn: getCompra,
    onError: (err) => {
      const originalError = err.cause || err.response || err;
      
      // chequeo un 403 que mando del back
      if (originalError?.status === 403) {
        toast.error("No tienes permisos para acceder a esta compra.");
        history.push('/unauthorized');
      } 
      // chequeo un 410 - compra cancelada
      else if (originalError?.status === 410) {
        toast.warning("Esta compra ha sido cancelada. Los tickets ya no están disponibles.", {
          position: "top-right",
          autoClose: 3000,
        });
        
        setTimeout(() => {
          history.push('/mis-compras');
        }, 3500);
      } 
      else {
        console.error("Error al obtener la compra:", err);
        toast.error("Error al cargar la compra");
      }
    },
  });

  useEffect(() => {
    if (!compraId) return;
    refetch(compraId);
    getMesasCompra(compraId).then(setMesas).catch(() => setMesas(null));
  }, [compraId]);

  const compra = useMemo(() => conMesas(data?.data?.compra, mesas), [data, mesas]);

  return {
    compra,
    loading,
    fetchCompra: refetch,
    unauthorized,
  }
}

export default useCompra;